import {chooseNoPlan, choosePlan} from 'actions/selectPlanActions';
import ContainerHeader from 'components/common/ContainerHeader';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {colors, containerStyles} from 'styles/shared';
import PlanItem from './components/PlanItem';

const PlansContainer = styled.div`
  width: 54.4rem;
  height: 81.8rem;
  margin-bottom: 5rem;
  margin-right: 5rem;
  padding: 3.9rem 4.9rem 4.9rem;
  ${containerStyles};

  > div {
    margin-bottom: 3.5rem;
  }
`;

const planStyles = [
  {
    icon: 'start-up',
    color: colors.blue_darker,
    background: colors.blue_light,
    checkColor: colors.blue_main
  },
  {
    icon: 'growth',
    color: colors.green_darker,
    background: colors.green_lighter,
    checkColor: colors.green_light
  },
  {
    icon: 'scale',
    color: colors.purple_dark,
    background: colors.purple_lighter,
    checkColor: colors.purple_light
  }
];

PlansSection.propTypes = {
  plans: PropTypes.object.isRequired
};

function selectedPlan(plans, id) {
  for (const plan of plans) {
    if (plan.id === id) {
      return plan;
    }
  }
  return null;
}

function PlansSection({plans}) {
  const [displayPlans, setDisplayPlans] = useState([]);
  const [activePlan, setActivePlan] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    let display: any = [];

    for (let key of Object.keys(plans)) {
      const plan = plans[key];

      let itemStyles = planStyles[display.length];

      let item = {
        id: plan.id,
        name: plan.name,
        overage: plan.overage,
        price: plan.price,
        requestQuota: plan.request_quota,
        price_id: plan.price_id,
        ...itemStyles
      };

      display.push(item);
    }

    setDisplayPlans(display);
  }, [plans]);

  function selectPlan(id) {
    setActivePlan(id);
    const plan = selectedPlan(displayPlans, id);
    if (plan === null) {
      dispatch(chooseNoPlan(null));
      return;
    }

    switch (plan.name) {
      case 'basic':
        dispatch(choosePlan(plan));
        break;
      case 'plus':
        dispatch(choosePlan(plan));
        break;
      case 'premium':
        dispatch(choosePlan(plan));
        break;
      default:
        dispatch(chooseNoPlan(null));
        break;
    }
  }

  function render() {
    return (
      <PlansContainer>
        <ContainerHeader>Plans</ContainerHeader>

        {displayPlans.map((plan: any) => {
          return <PlanItem key={plan.id} plan={plan} activePlan={activePlan} onSelect={selectPlan} />;
        })}
      </PlansContainer>
    );
  }

  return render();
}

export default PlansSection;
